import PostsAdapter from './base';

export default class Staffnotice extends PostsAdapter {
  modelNamePlural = 'staffnotices';
}
